import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from "recharts";

const DOMAIN_LABELS = {
  logical_reasoning: "Logic",
  fluid_reasoning: "Fluid",
  pattern_recognition: "Patterns",
  visual_spatial: "Spatial",
  working_memory: "Memory",
  verbal_reasoning: "Verbal",
  quantitative_reasoning: "Quant",
  processing_efficiency: "Speed",
  cognitive_flexibility: "Flex",
  emotional_recognition: "Emotion",
  perspective_taking: "Perspective",
  social_reasoning: "Social",
  conflict_navigation: "Conflict",
  communication_judgment: "Comm.",
  emotional_regulation: "Regulation",
  empathic_reasoning: "Empathy",
  self_awareness: "Self-Aware",
};

export default function RadarViz({ domainScores }) {
  const cog = Object.entries(domainScores || {}).filter(([, v]) => v.layer === "cognitive");
  const eq = Object.entries(domainScores || {}).filter(([, v]) => v.layer === "emotional");
  const keys = Array.from(new Set([...cog, ...eq].map(([k]) => k)));
  const data = keys.map((k) => ({
    domain: DOMAIN_LABELS[k] || k,
    Cognitive: domainScores[k]?.layer === "cognitive" ? domainScores[k].score : 0,
    Emotional: domainScores[k]?.layer === "emotional" ? domainScores[k].score : 0,
  }));

  return (
    <div className="w-full h-[380px] sm:h-[440px]" data-testid="dualq-radar">
      <ResponsiveContainer>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#1A2847" />
          <PolarAngleAxis dataKey="domain" tick={{ fill: "#94A3B8", fontSize: 11 }} />
          <PolarRadiusAxis domain={[0, 100]} tick={{ fill: "#475569", fontSize: 10 }} axisLine={false} />
          <Radar name="Cognitive" dataKey="Cognitive" stroke="#38BDF8" fill="#38BDF8" fillOpacity={0.25} />
          <Radar name="Emotional" dataKey="Emotional" stroke="#F59E0B" fill="#F59E0B" fillOpacity={0.25} />
          <Legend wrapperStyle={{ color: "#94A3B8", fontSize: 12 }} />
          <Tooltip contentStyle={{ background: "#0E172A", border: "1px solid #1A2847", borderRadius: 8, color: "#F8FAFC" }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
